import { Component } from '@angular/core';
import { FOOTER_LINKS } from '../app.constants';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <footer class="footer">
      <span>&copy; 2026 Asian Development Bank.</span>
      @for (link of links; track link.label) {
        @if (link.href) {
          <a class="footer__link" [href]="link.href" target="_blank" rel="noopener noreferrer">{{
            link.label
          }}</a>
        } @else {
          <a class="footer__link">{{ link.label }}</a>
        }
      }
    </footer>
  `,
  styleUrl: './app-footer.scss',
})
export class AppFooter {
  readonly links = FOOTER_LINKS;
}
